import React from 'react';
import ServerApi from './serverApi';

const ServerApiContext = React.createContext<ServerApi>(new ServerApi());

export default ServerApiContext;
